import { resolveEmbedApiBaseUrl } from './context-api';
import type {
    CustomButtonStyleConfig,
    FloatingButtonStyleConfig,
    VotiqInitOptions,
    VotiqTabsConfig,
} from './types';

export interface WidgetEmbedConfigResponse {
    projectId: string;
    enabled: boolean;
    theme: VotiqInitOptions['theme'];
    position: VotiqInitOptions['position'];
    buttonType: VotiqInitOptions['buttonType'];
    floatingIcon: VotiqInitOptions['floatingIcon'];
    launcherIconPreset: string | null;
    customLauncherIconUrl: string | null;
    darkLauncher: boolean;
    launcherLabel: string;
    welcomeTitle: string;
    welcomeMessage: string;
    tabs: VotiqTabsConfig;
    options: Record<string, unknown>;
    customButton: CustomButtonStyleConfig;
    floatingButton: FloatingButtonStyleConfig;
}

export async function fetchWidgetEmbedConfig(
    projectId: string,
    apiBaseUrl?: string,
): Promise<WidgetEmbedConfigResponse> {
    const base = resolveEmbedApiBaseUrl(apiBaseUrl);
    const url = new URL(
        `/api/widget/v1/projects/${encodeURIComponent(projectId)}/embed`,
        base || undefined,
    );

    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'omit',
    });

    if (!response.ok) {
        throw new Error(`Widget config request failed (${response.status})`);
    }

    return (await response.json()) as WidgetEmbedConfigResponse;
}

export function embedConfigToInitOptions(
    config: WidgetEmbedConfigResponse,
    apiBaseUrl: string,
): VotiqInitOptions {
    return {
        projectId: config.projectId,
        enabled: config.enabled,
        theme: config.theme,
        position: config.position,
        buttonType: config.buttonType,
        floatingIcon: config.floatingIcon,
        launcherIconPreset: config.launcherIconPreset,
        customLauncherIconUrl: config.customLauncherIconUrl,
        darkLauncher: config.darkLauncher,
        launcherLabel: config.launcherLabel,
        welcomeTitle: config.welcomeTitle,
        welcomeMessage: config.welcomeMessage,
        tabs: config.tabs,
        customButton: config.customButton,
        floatingButton: config.floatingButton,
        apiBaseUrl,
    };
}
